module.exports = __webpack_public_path__ + "img/Riki.50e58176.png";